import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import Navbar from '../navbar/Navbar';

import explore from '../../img/explore.png';
import icon_park from '../../img/icon_park.png';
import user_icon from '../../img/user_icon.png';
import bill from '../../img/bill.png';
import support from '../../img/support.png';
import faq from '../../img/faq.png';
import setting from '../../img/setting.png';

import overview_page_image from '../../img/overview_page_image.png';
import pricing_image from '../../img/pricing_image.png';
import guide_page_sidebar from '../../img/guide_page_sidebar.png';
import ecom_core from '../../img/ecom_core.png';
import qcom_core from '../../img/qcom_core.png';
import api_key_snap from '../../img/api_key_snap.PNG';
import transaction_history_snap from '../../img/transaction_histort_snap.png';
import plan_and_billing_snap from '../../img/plan_and_billing_snap.png';
import api_usage_snap from '../../img/api_usage_snap.PNG';
import your_profile_snap from '../../img/your_profile_snap.png';
import pricing_snap from '../../img/pricing_snap.png';
import contact_us_snap from '../../img/contact_us_snap.png';

import ecom_logo_color from '../../img/ecom_logo_color.png';

import '../../css/otherComponents/help.css';

const Help = ({ auth: { isAuthenticated, user } }) => {
  const sectionRefs = useRef([]);

  const topics = [
    {
      id: 1,
      icon: explore,
      title: 'Explore Plan or Price Plan',
      description: 'Plan selection option and payment method.',
      targetId: 'explore-plan',
    },
    {
      id: 2,
      icon: icon_park,
      title: 'Using Ecom Next API',
      description: 'Performing core function and navigating menu.',
      targetId: 'using-ecom-next-api',
    },
    {
      id: 3,
      icon: user_icon,
      title: 'Account',
      description:
        'View account details, Reset Password and Update profile information.',
      targetId: 'account',
    },
    {
      id: 4,
      icon: setting,
      title: 'Settings',
      description: 'Subscriptions, Payment and Invoice details.',
      targetId: 'settings',
    },
    {
      id: 5,
      icon: support,
      title: 'Contacting Support',
      description: 'Contact support for any assistance needed.',
      targetId: 'support',
    },
    {
      id: 6,
      icon: faq,
      title: 'FAQs',
      description: 'Find answers to frequently asked questions.',
      targetId: 'faq',
    },
  ];

  return (
    <div className='min-h-screen'>
      <div>
        <Navbar />
      </div>

      <div className=' p-6 pt-0'>
        {/* Heading */}
        {/* <div className='sticky top-0 bg-[#F5F7F8]  z-10'> */}
        <h1 className='top-heading mb-3.5 mt-[88px]'>Browse by topic</h1>

        {/* Sticky Cards Grid */}

        <div className='grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-y-[26px] gap-x-[42px]'>
          {topics.map((topic, index) => (
            <div
              key={topic.id}
              className='flex items-center bg-white shadow-md rounded-lg p-4 hover:shadow-lg transition cursor-pointer'
              onClick={() => {
                if (topic.targetId) {
                  document
                    .getElementById(topic.targetId)
                    ?.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              <img
                src={topic.icon}
                alt={topic.title}
                className='h-12 w-12 mr-4'
              />
              <div>
                <h2 className='text-lg font-semibold'>{topic.title}</h2>
                <p className='text-gray-600 text-sm'>{topic.description}</p>
              </div>
            </div>
          ))}
        </div>
        {/* </div> */}

        {/* Overview Section */}
        <div className='mt-[86px] text-center max-w-full'>
          <h2 className='help-overview-heading mb-4'>
            Overview of Ecomnext API
          </h2>
          <p className='help-overview-text text-gray-700 text-lg text-balance'>
            The EcomNext API is your ultimate gateway to seamlessly integrating
            with leading eCommerce and quick commerce platforms. It enables
            businesses to gain real-time access to crucial product data,
            pricing, and availability, ensuring that you stay competitive in
            today’s dynamic market. Whether you’re a seasoned player or an
            emerging business, EcomNext API helps you streamline operations and
            make informed decisions, with consolidated data from the platforms
            that matter most.
          </p>
        </div>

        {/* Overview Page Details Section */}
        <div className='mt-[86px] border border-gray-300 rounded-lg p-6 w-full max-w-full'>
          <div className='grid grid-cols-1 lg:grid-cols-2 gap-6 items-center'>
            {/* Left Side - Text */}
            <div>
              <h2 className='text-xl font-bold mb-4'>Overview Page</h2>
              <h3 className='text-lg font-semibold'>
                1. Header: Contains navigation links for
              </h3>
              <ul className='list-disc pl-6 mt-2 text-gray-700'>
                <li>
                  <strong>My Profile:</strong> To check user details.
                </li>
                <li>
                  <strong>Plans:</strong> Select your preferred plan.
                </li>
                <li>
                  <strong>Contact Us:</strong> Write your queries to us or
                  request a Demo.
                </li>
                <li>
                  <strong>Logout:</strong> Logout from the application.
                </li>
              </ul>
            </div>

            {/* Right Side - Image */}
            <div className='flex justify-center'>
              <img
                src={overview_page_image}
                alt='Overview Page'
                className='max-w-full overview-page-image rounded-lg shadow-md'
              />
            </div>
          </div>
        </div>

        {/* Explore Pricing Plan Heading */}
        <div className='mt-[86px] flex items-center gap-3' id='explore-plan'>
          <img src={explore} alt='Explore' className='h-[45px] w-[45px]' />
          <h2 className='page-section-heading'>Explore Pricing Plan</h2>
        </div>

        {/* Pricing Plan Section */}
        <div className='mt-[44px] border border-gray-300 rounded-lg px-6 py-[58px] w-full max-w-full'>
          <div className='grid grid-cols-1 lg:grid-cols-2 gap-6 items-center'>
            {/* Left Side - Plan Details */}
            <div>
              <h2 className='top-heading mb-4'>Plan Selection Option</h2>
              <ol className='list-decimal pl-6 help-section-text space-y-[40px]'>
                <li>
                  <p>
                    <span className='font-medium text-font_color-20'>
                      Professional Plan:
                    </span>{' '}
                    Unlock actionable pricing insights, detailed product
                    descriptions, real-time availability tracking, keyword
                    performance monitoring, and seamless support with email
                    assistance and custom development options—all in one
                    comprehensive API solution.
                  </p>
                  <Link to='/pricing'>
                    <button className='mt-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition'>
                      Buy Plan
                    </button>
                  </Link>
                </li>

                <li>
                  <p>
                    <span className='font-medium text-font_color-20'>
                      Customized Plan:
                    </span>{' '}
                    Professional+ offers advanced data storage solutions,
                    tailored software customization, real-time product
                    availability, access to solution specialists, and exclusive
                    assistance services for a premium experience.
                  </p>
                  <Link to='/contact-us'>
                    <button className='mt-2 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition'>
                      Schedule a Call
                    </button>
                  </Link>
                </li>
              </ol>
            </div>

            {/* Right Side - Pricing Image */}
            <div className='flex justify-center'>
              <img
                src={pricing_image}
                alt='Pricing Plan'
                className='max-w-full rounded-lg shadow-md pricing-image'
              />
            </div>
          </div>
        </div>

        {/* Payment Methods Section (No Image) */}
        <div className='mt-[42px] border border-gray-300 rounded-lg p-6 w-full max-w-full'>
          <h2 className='top-heading mb-4'>Payment Methods</h2>
          <ol className='list-decimal pl-6 help-section-text space-y-4'>
            <li>
              Once the user clicks on the “Buy” button, they will be directed to
              the payment methods page where they can choose from the following
              options:
            </li>
            <li>
              Card Payment: Users can pay using their credit or debit cards.
            </li>
            <li>
              UPI/QR Payment: Users can pay via UPI or by scanning a QR code.
            </li>
            <li>
              Net Banking: Users can pay through their bank's net banking
              service.
            </li>
            <li>
              Once the payment is made successfully, the user can experience the
              features of the Ecomnext API.
            </li>
          </ol>
        </div>

        {/* Using Ecomnext API Heading */}
        <div
          className='mt-[86px] flex items-center w-full max-w-screen-lg'
          id='using-ecom-next-api'
        >
          <img
            src={icon_park}
            alt='API Usage'
            className='h-[45px] w-[45px] mr-3'
          />
          <h2 className='page-section-heading'>Using Ecomnext API</h2>
        </div>

        {/* Navigating the Menu Section */}
        <div className='mt-6 border border-gray-300 rounded-lg p-6 w-full max-w-full'>
          <div className='grid grid-cols-1 lg:grid-cols-2 gap-6 items-center'>
            {/* Left Side (Text Content) */}
            <div>
              <h2 className='top-heading mb-[44px]'>Navigating the Menu</h2>

              {/* Overview Section */}
              <h3 className='help-section-sub-heading'>Overview: Click on</h3>
              <ul className='list-disc pl-6 mt-2 help-section-text space-y-2'>
                <li>
                  <strong>Price Monitoring:</strong> Access real-time price
                  updates.
                </li>
                <li>
                  <strong>Product Out of Stock:</strong> Access real-time stock
                  status updates.
                </li>
                <li>
                  <strong>New Product Launches:</strong> Access updates on new
                  product launches.
                </li>
              </ul>

              {/* E-Commerce Section */}
              <h3 className='help-section-sub-heading mt-[40px]'>E-Commerce</h3>
              <ol className='list-decimal pl-6 mt-2 help-section-text space-y-2'>
                <li>
                  <strong>Amazon:</strong> Click on the Amazon card to navigate
                  to the Amazon API page.
                </li>
                <li>
                  <strong>Flipkart:</strong> Click on the Flipkart card to
                  navigate to the Flipkart API page.
                </li>
                <li>
                  <strong>Snapdeal:</strong> Click on the Snapdeal card to
                  navigate to the Snapdeal API page.
                </li>
                <li>
                  <strong>Firstcry:</strong> Click on the Firstcry card to
                  navigate to the Firstcry API page.
                </li>
                <li>
                  <strong>TATA 1mg:</strong> Click on the TATA 1mg card to
                  navigate to the TATA 1mg API page.
                </li>
                <li>
                  <strong>Netmeds:</strong> Click on the Netmeds card to
                  navigate to the Netmeds API page.
                </li>
              </ol>

              {/* Quick Commerce Section */}
              <h3 className='help-section-sub-heading mt-[40px]'>
                Quick Commerce
              </h3>
              <ol className='list-decimal pl-6 mt-2 help-section-text space-y-2'>
                <li>
                  <strong>Zepto:</strong> Click on the Zepto card to navigate to
                  the Zepto API page.
                </li>
                <li>
                  <strong>Instamart:</strong> Click on the Instamart card to
                  navigate to the Instamart API page.
                </li>
                <li>
                  <strong>Blinkit:</strong> Click on the Blinkit card to
                  navigate to the Blinkit API page.
                </li>
                <li>
                  <strong>BigBasket:</strong> Click on the BigBasket card to
                  navigate to the BigBasket API page.
                </li>
              </ol>
            </div>

            {/* Right Side (Image) */}
            <div className='flex justify-center'>
              <img
                src={guide_page_sidebar}
                alt='Guide Page Sidebar'
                className='max-w-full guide-page-sidebar rounded-lg shadow-md'
              />
            </div>
          </div>
        </div>

        {/* Performing Core Functions Section */}
        <div className='mt-[86px] border border-gray-300 rounded-lg p-6 w-full max-w-full'>
          <h2 className='page-section-heading mb-[18px]'>
            Performing Core Functions
          </h2>

          {/* E-Commerce Section */}
          <div className='grid grid-cols-1 lg:grid-cols-2 gap-6 items-center'>
            {/* Left Side */}
            <div>
              <div className='flex items-center mb-4'>
                <span className='help-colored-numbering bg-blue-600 text-white rounded-full h-8 w-8 flex items-center justify-center text-lg font-bold mr-3'>
                  1
                </span>
                <h3 className='page-section-second-heading'>E-Commerce</h3>
              </div>
              <ol className='list-decimal pl-6 help-section-text space-y-2'>
                <li>Navigate to the E-Commerce section from the menu.</li>
                <li>Select the e-commerce platform (e.g., Amazon).</li>
                <li>Select options like Python, Curl, or JavaScript.</li>
                <li>
                  Learn "How to Implement EcomNext API in Your Application".
                </li>
              </ol>
            </div>

            {/* Right Side (Image) */}
            <div className='flex justify-center'>
              <img
                src={ecom_core}
                alt='E-Commerce Core'
                className='max-w-full ecom-core rounded-lg shadow-md'
              />
            </div>
          </div>

          {/* Quick Commerce Section */}
          <div className='grid grid-cols-1 lg:grid-cols-2 gap-6 items-center mt-8'>
            {/* Left Side */}
            <div>
              <div className='flex items-center mb-4'>
                <span className='bg-green-600 text-white rounded-full h-8 w-8 flex items-center justify-center text-lg font-bold mr-3'>
                  2
                </span>
                <h3 className='page-section-second-heading'>Quick Commerce</h3>
              </div>
              <ol className='list-decimal pl-6 help-section-text space-y-2'>
                <li>Navigate to the Quick Commerce section from the menu.</li>
                <li>Select the quick commerce platform (e.g., Amazon).</li>
                <li>Select options like Python, Curl, or JavaScript.</li>
                <li>
                  Learn "How to Implement EcomNext API in Your Application".
                </li>
              </ol>
            </div>

            {/* Right Side (Image) */}
            <div className='flex justify-center'>
              <img
                src={qcom_core}
                alt='Quick Commerce Core'
                className='max-w-full h-auto rounded-lg shadow-md'
              />
            </div>
          </div>
        </div>

        {/* Settings Section */}
        {/* Using Ecomnext API Heading */}
        <div
          className='mt-[86px] flex items-center w-full max-w-screen-lg'
          id='settings'
        >
          <img
            src={setting}
            alt='API Usage'
            className='h-[45px] w-[45px] mr-3'
          />
          <h2 className='page-section-heading'>Settings</h2>
        </div>
        <div
          className='mt-[24px] border border-gray-300 rounded-lg p-6 w-full max-w-full'
          id=''
        >
          {/* API Key Section */}
          <div className='grid grid-cols-1 lg:grid-cols-2 gap-6 items-center'>
            <div>
              <div className='flex items-center mb-[71px]'>
                <span className='bg-purple-600 text-white rounded-full h-8 w-8 flex items-center justify-center text-lg font-bold mr-3'>
                  1
                </span>
                <h3 className='page-section-second-heading'>API Key</h3>
              </div>
              <p className='help-section-text mb-[71px]'>
                The API key section allows users to securely manage their API
                access. Users can generate and view API keys for immediate use.
                If a key expires or gets compromised, they can regenerate a new
                key to maintain secure access.
              </p>
            </div>
            <div className='flex justify-center'>
              <img
                src={api_key_snap}
                alt='API Key'
                className='max-w-full h-auto rounded-lg shadow-md'
              />
            </div>
          </div>

          {/* API Usage Section */}
          <div className='grid grid-cols-1 lg:grid-cols-2 gap-6 items-center mt-8'>
            <div>
              <div className='flex items-center mb-[71px]'>
                <span className='bg-orange-600 text-white rounded-full h-8 w-8 flex items-center justify-center text-lg font-bold mr-3'>
                  2
                </span>
                <h3 className='page-section-second-heading'>API Usage</h3>
              </div>
              <p className='help-section-text mb-[71px]'>
                The API usage section provides insights into API activity,
                including details on API name, token consumption, and
                timestamps. Users can also download detailed reports for
                analysis and record-keeping.
              </p>
            </div>
            <div className='flex justify-center'>
              <img
                src={api_usage_snap}
                alt='API Usage'
                className='max-w-full h-auto rounded-lg shadow-md'
              />
            </div>
          </div>

          {/* Transaction History Section */}
          <div className='grid grid-cols-1 lg:grid-cols-2 gap-6 items-center mt-8'>
            <div>
              <div className='flex items-center mb-[71px]'>
                <span className='bg-red-600 text-white rounded-full h-8 w-8 flex items-center justify-center text-lg font-bold mr-3'>
                  3
                </span>
                <h3 className='page-section-second-heading'>
                  Transaction History
                </h3>
              </div>
              <p className='help-section-text mb-[71px]'>
                The transaction history section provides a complete log of
                payments made for API services, including transaction dates,
                amounts, and payment methods, ensuring transparency in financial
                records.
              </p>
            </div>
            <div className='flex justify-center'>
              <img
                src={transaction_history_snap}
                alt='Transaction History'
                className='max-w-full h-auto rounded-lg shadow-md'
              />
            </div>
          </div>

          {/* Plan & Billing Section */}
          <div
            className='grid grid-cols-1 lg:grid-cols-2 gap-6 items-center mt-8'
            id='billing'
          >
            <div>
              <div className='flex items-center mb-4'>
                <span className='bg-teal-600 text-white rounded-full h-8 w-8 flex items-center justify-center text-lg font-bold mr-3'>
                  4
                </span>
                <h3 className='page-section-second-heading'>Plan & Billing</h3>
              </div>
              <p className='help-section-text'>
                This section provides details on the active monthly plan, its
                expiration date, and the remaining token balance available for
                use.
              </p>
            </div>
            <div className='flex justify-center'>
              <img
                src={plan_and_billing_snap}
                alt='Plan & Billing'
                className='max-w-full h-auto rounded-lg shadow-md'
              />
            </div>
          </div>
        </div>

        {/* Account Setting Section */}
        <div className='mt-[86px] w-full max-w-full' id='account'>
          <div className='flex items-center mb-4'>
            <img
              src={user_icon}
              alt='User Icon'
              className='h-[45px] w-[45px] mr-3'
            />
            <h2 className='page-section-heading'>Account</h2>
          </div>
          <div className='border border-gray-300 rounded-lg px-6 py-[45px] w-full flex flex-col lg:flex-row items-center lg:items-start'>
            <div className='lg:w-1/2'>
              <h3 className='page-section-second-heading mb-4'>
                Updating Profile Information
              </h3>
              <ol className='list-decimal pl-6 help-section-text space-y-4'>
                <li>
                  Select{' '}
                  <span className='text-font_color-20 font-medium'>
                    "Your Profile"
                  </span>{' '}
                  from the Sidebar menu.
                </li>
                <li>Can view and edit the details of the user.</li>
              </ol>
            </div>
            <div className='lg:w-1/2 flex justify-center lg:mt-0'>
              <img
                src={your_profile_snap}
                alt='Your Profile'
                className='rounded-lg shadow-md your-profile-snap'
              />
            </div>
          </div>
        </div>

        {/* Billing Setting Section */}
        {/* <div className='mt-[86px] w-full max-w-full'>
          <div className='flex items-center mb-[40px]'>
            <img
              src={bill}
              alt='bill Icon'
              className='h-[45px] w-[45px] mr-3'
            />
            <h2 className='page-section-heading'>Pricing</h2>
          </div>
          <div className='border border-gray-300 rounded-lg p-6 w-full flex flex-col lg:flex-row items-center lg:items-start'>
            <div className='lg:w-1/2'>
              <h3 className='page-section-second-heading mb-4'>
                Types of available pricing
              </h3>
              <ol className='list-decimal pl-6 help-section-text space-y-4'>
                <li>
                  Select{' '}
                  <span className='text-font_color-20 font-medium'>
                    "Pricing Plan"
                  </span>{' '}
                  from the sidebar menu.
                </li>
                <li>Naviag to pricing plan page.</li>
                <li>You can select the plan that fit's your requirement.</li>
              </ol>
            </div>
            <div className='lg:w-1/2 flex justify-center mt-4 lg:mt-0'>
              <img
                src={pricing_snap}
                alt='Pricing plan'
                className='pricing-snap rounded-lg shadow-md'
              />
            </div>
          </div>
        </div> */}

        {/* Contacting Suppport Section */}
        <div className='mt-[86px] w-full max-w-full' id='support'>
          <div className='flex items-center mb-4'>
            <img
              src={support}
              alt='User Icon'
              className='h-[45px] w-[45px] mr-3'
            />
            <h2 className='page-section-heading'>Contacting Support</h2>
          </div>
          <div className=' border border-gray-300 rounded-lg p-6 w-full flex flex-col lg:flex-row items-center lg:items-start'>
            <div className='lg:w-1/2'>
              <ol className='list-decimal pl-6 help-section-text space-y-4'>
                <li>
                  Select{' '}
                  <span className='text-font_color-20 font-medium'>
                    "Contact us"
                  </span>{' '}
                  from the sidebar menu.
                </li>
                <li>Fill out the form with your queries/issues.</li>
                <li>Click send message.</li>
              </ol>
            </div>
            <div className='lg:w-1/2 flex justify-center lg:mt-0'>
              <img
                src={contact_us_snap}
                alt='contact us snap'
                className='contact-us-snap rounded-lg shadow-md'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// export default Help;

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(Help);
